<div class="body">

    <mat-toolbar class="ams-toolbar">
        <mat-icon class="main-icon">warning</mat-icon>
        <span>
            Invalides Notizformat
        </span>
        <span class="spacer"></span>
        <button mat-icon-button (click)="close()" color="warn">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>

    <div class="content">

        <div class="info">

            Die Notiz ist in einem unerwarteten Format. 
            Dies tritt für gewöhnlich bei Versionsänderungen des Wista AMS auf. 
            Sie können diesen Fehler beheben, indem Sie die Notiz jetzt konvertieren. 
            Bitte überprüfen Sie dazu, ob die Notiz unterhalb richtig dargestellt wird. 
            Sie können auch auf <code>Nächstest Format</code> klicken, um eine andere Formatierung zu testen.

        </div>

        <div class="quill-wrapper">

            <quill-view *ngIf="rendered" @show [content]="convertedNote" [format]="currentFormat" #quill></quill-view>

        </div>

        <div class="footer">

            <button mat-raised-button (click)="nextFormat()">
                Nächstes Format
            </button>

            <button mat-raised-button (click)="confirm()" color="primary">
                Konvertieren
            </button>
    
        </div>

    </div>

</div>